import { auth } from '@/plugins/firebase'
import state from '@/state'
import Vue from 'vue'
import VueRouter from 'vue-router'
import cashRegister from './cash-register'
import companies from './companies'
import company from './company'
import pointOfSale from './point-of-sale'

Vue.use(VueRouter)
const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '@/components/Login')
  },
  {
    path: '/loginStage',
    name: 'LoginStage',
    component: () => import(/* webpackChunkName: "login" */ '@/components/LoginStage')
  },
  {
    path: '/helpdesk',
    name: 'Helpdesk',
    beforeEnter: () => {
      window.location.href = 'https://aduroidea.com/helpdesk'
    }
  },
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "Business" */ '@/modules/home/Home'),
    redirect: { name: 'companies' },
    meta: {
      requiresAuth: true,
      sideNav: 'Companies',
      topBar: 'CompaniesTopBar'
    },
    children: [
      companies,
      company,
      pointOfSale,
      cashRegister,
      {
        path: '/users',
        name: 'users',
        component: () => import(/* webpackChunkName: "Users" */ '@/modules/companies/components/users/Users'),
        meta: {
          title: '$vuetify.users.titleText',
          addItemText: '$vuetify.users.addUser',
          addItemAction: 'addUser',
          filterSearch: false,
          requiresAuth: true,
          labelText: '$vuetify.users.searchLabelText',
          sideNav: 'Companies',
          topBar: 'CompaniesTopBar'
        }
      },
      {
        path: '/instructions',
        name: 'instructions',
        component: () => import(/* webpackChunkName: "Users" */ '@/modules/companies/components/instructions/Instructions'),
        meta: {
          noAddButton: true,
          removeSearch: true,
          removeGrid: true,
          title: '$vuetify.instructions.titleText',
          filterSearch: false,
          requiresAuth: true,
          sideNav: 'Companies',
          topBar: 'CompaniesTopBar'
        }
      }
    ]
  },

  {
    path: '/password-reset',
    name: 'PasswordReset',
    component: () => import(/* webpackChunkName: "login" */ '@/components/PasswordReset')
  },
  {
    path: '/user-manual',
    name: 'userManual',
    component: () => import(/* webpackChunkName: "UserManual" */ '@/modules/user-manual/UserManual'),
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/menu/:locationId',
    name: 'PublicMenu',
    component: () => import(/* webpackChunkName: "PublicMenu" */ '@/modules/public-menu/PublicMenuWrapper'),
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/posd',
    name: 'Posd',
    component: () => import(/* webpackChunkName: "Business" */ '@/modules/posd/Posd')
  },
  {
    path: '*',
    name: 'catchall',
    component: () => import(/* webpackChunkName: "error404" */'@/components/error404')
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

// Track if auth has been initialized at least once
let authInitialized = false

// Function to check if auth is ready
const waitForAuthInit = () => {
  if (authInitialized) {
    return Promise.resolve()
  }
  return new Promise((resolve) => {
    const unsubscribe = auth.onAuthStateChanged(() => {
      authInitialized = true
      unsubscribe()
      resolve()
    })
  })
}

router.beforeEach(async (to, from, next) => {
  // Wait for Firebase Auth to initialize only on first navigation
  await waitForAuthInit()

  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)

  const adminOnlyRoutes = [
    name => name.includes('all-reports'),
    name => name.includes('userData.bill'),
    name => name === 'users' || name.endsWith('.users')
  ]

  if (to.name && adminOnlyRoutes.some(match => match(to.name))) {
    const roles = state.getUser()?.roles || {}
    if (!roles.SUPERADMIN && !roles.ADMIN && !roles.KNJIGOVOĐA) {
      next({ name: 'companies' })
      return
    }
  }

  if (requiresAuth && (!auth.currentUser || !auth.currentUser.emailVerified)) {
    // User needs to be authenticated but isn't
    if (process.env.VUE_APP_FIREBASE_PROJECT_ID === 'ai-fisk-stage') {
      next({ name: 'LoginStage' })
    } else {
      next({ name: 'Login' })
    }
  } else if (!requiresAuth && auth.currentUser && auth.currentUser.emailVerified && (to.name === 'Login' || to.name === 'LoginStage')) {
    // If user is already logged in and tries to access login page, redirect to home
    next({ name: 'Home' })
  } else {
    // Allow navigation
    next()
  }
})
export default router
